import { ProductOpaqueValue } from "@b2bportal/purchase-api";
import { IContactInfo, PassengerMap } from "../../../../../types";

export enum PriceFreezeOfferEvent {
  // CommonEvents
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
  CHANGE = "CHANGE",
  GO_IDLE = "GO_IDLE",
  RESET_CONTEXT = "RESET_CONTEXT",

  // ContactInformationEvents
  UPDATE_EMAIL = "UPDATE_EMAIL",
  UPDATE_PHONENUMBER = " UPDATE_PHONENUMBER",
  SET_CONTACT_INFO = "SET_CONTACT_INFO",
  CLEAR_CONTACT_ERROR = "CLEAR_CONTACT_ERROR",

  // Passenger
  SET_PASSENGER_MAP = "SET_PASSENGER_MAP",

  // PriceFreezeOffer
  SET_PRICE_FREEZE_DURATION_INDEX = "SET_PRICE_FREEZE_DURATION_INDEX",

  // Cart Product
  ADD_PRICE_FREEZE_PRODUCT_TO_CART = "ADD_PRICE_FREEZE_PRODUCT_TO_CART",
}

export interface NextEvent {
  type: PriceFreezeOfferEvent.NEXT;
}
export interface PreviousEvent {
  type: PriceFreezeOfferEvent.PREVIOUS;
}

export interface SetContactInfoEvent {
  type: PriceFreezeOfferEvent.SET_CONTACT_INFO;
  contactInfo: IContactInfo;
}

export interface SetPassengerMapEvent {
  type: PriceFreezeOfferEvent.SET_PASSENGER_MAP;
  passengerMap: PassengerMap;
}

export interface GoIdleEvent {
  type: PriceFreezeOfferEvent.GO_IDLE;
}

export interface SetPriceFreezeDurationIndex {
  type: PriceFreezeOfferEvent.SET_PRICE_FREEZE_DURATION_INDEX;
  duration: number;
}

export interface ResetContextEvent {
  type: PriceFreezeOfferEvent.RESET_CONTEXT;
}

export interface ClearContactError {
  type: PriceFreezeOfferEvent.CLEAR_CONTACT_ERROR;
}

export interface AddPriceFreezeProduct {
  type: PriceFreezeOfferEvent.ADD_PRICE_FREEZE_PRODUCT_TO_CART;
  passengerMap: ProductOpaqueValue;
}

export type AirPriceFreezeEvents =
  | GoIdleEvent
  | NextEvent
  | PreviousEvent
  | SetContactInfoEvent
  | ResetContextEvent
  | ClearContactError
  | SetPriceFreezeDurationIndex
  | SetPassengerMapEvent
  | AddPriceFreezeProduct;
